import { Paging } from '../shared-typed'

export type CreateCampaignBody = {
  title: string
  startDate: string
  endDate: string
  body?: string
  buttonName: string
  route?: string
  thumnailImage?: string
  type: EnumCampaignType
  redirectUrl?: string
}

export enum EnumCampaignPath {
  market = '/market-place',
  // profile = '/profile',
  faq = '/faq',
  buy = '/buy-option/buy-now',
  sell = '/sell-gold/true-money',
}

export type CampaignResponseType = {
  id: string
  createdAt: string
  updatedAt: string
  deletedAt: string | null
  body: string
  creatorId: string
  updaterId: string
  title: string
  buttonName: string
  route: string
  thumbnailImage?: string
  startDate: Date
  endDate: Date
  type: string
  redirectUrl?: string
}

export type CampaignListResponseType = {
  items: CampaignResponseType[]
  meta: Paging
}

export enum EnumCampaignType {
  CONTENT = 'content',
  DEEP_LINK = 'deepLink',
}
